<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode"
    [characterCount]="characterCount"
    [focused]="focused()">
    @if (isEditMode) {
        <kendo-textarea
            [id]="id"
            [title]="title | translate"
            [placeholder]="placeholder"
            [maxlength]="maxLength"
            [disabled]="isDisabled"
            [required]="isRequired"
            [ngClass]="generateInputStyle()"
            [rows]="rows"
            [(ngModel)]="value"
            (valueChange)="onValueChange($event)"
            (focusin)="onFocusIn()"
            (focusout)="onFocusOut()"
            (keypress)="onKeyPress($event)">
            <ng-template kendoTextBoxSuffixTemplate>
                <ng-content select=".textbox-suffix"></ng-content>
            </ng-template>
        </kendo-textarea>
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="pt-1.5 pb-1 whitespace-pre-wrap">{{ value() }}</div>
    }
</app-input-label>
